import React from "react";
import { CardBody } from "reactstrap";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Brush,
} from "recharts";

interface ForecastItem {
  date: string;
  value: number;
  confidence: number;
}

interface GraphProps {
  data: ForecastItem[];
}

const Graph: React.FC<GraphProps> = ({ data }) => {
  return (
      <div className="table-border border p-3">
        <div className=''>
          <CardBody>
            <div className="d-flex flex-row gap-2">
              <h5 className="rv-page-title">Forecast Chart</h5>
            </div>
            <ResponsiveContainer width="100%" height={350}>
              <LineChart data={data} margin={{ top: 20, right: 120, left: 80, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip
                  labelFormatter={(label) => `Date: ${label}`}
                  formatter={(value: any) => [
                    `${value.toFixed(2)}`,
                    "Forecast Value",
                  ]}
                />

                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#8884d8"
                  strokeWidth={2}
                  dot={{ stroke: "#8884d8", strokeWidth: 2 }}
                />

                <Brush dataKey="date" height={20} stroke="#8884d8" />
              </LineChart>
            </ResponsiveContainer>
          </CardBody>
        </div>
      </div>
  );
};

export default Graph;
